<template>
  <div class="container-fluid">
    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Saldos de cuentas corrientes de proveedores</h1>
          <p class="view-header__subtitle">Balance acumulado por proveedor {{ toDate ? `hasta el ${toDate}` : 'a la fecha' }}.</p>
        </div>
      </div>
    </div>

    <!-- STATS -->
    <div class="row">
      <div class="col-12">
        <div class="stats-card">
          <div class="stats-card__value">{{ formatoDinamicoMoneda(total) }}</div>
          <div class="stats-card__label">
            Balance de cuentas corrientes
            <span v-if="toDate"> · hasta el {{ toDate }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__row">
          <div class="filters-panel__field filters-panel__field--inline">
            <label class="control-label">Fecha:</label>
            <datepicker-component
              :dateLabel="'Seleccione una fecha'"
              :defaultDate="toDate"
              v-on:datechoosed="toDateUpdated"
            />
          </div>
          <div class="filters-panel__actions">
            <button type="button" class="filters-panel__btn" @click="exportCSV">
              <i class="bi bi-filetype-csv"></i>
              Exportar CSV
            </button>
            <button type="button" class="filters-panel__btn" @click="exportPDF">
              <i class="bi bi-filetype-pdf"></i>
              Exportar PDF
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- TABLA -->
    <div class="data-table">
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="opts"
        :selectCheckbox="0"
        container-class-name="table-responsive"
        class-name="table mb-0"
      />
    </div>
  </div>
</template>

<script>
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import formatMoneyMixin from "./../../mixins/formatMoneyMixin";
import formatDateMixin from "../../mixins/formatDateMixin";
import datepickerComponent from '../global/Datepicker-empty.vue';

export default {
  components: {
    VdtnetTable,
    datepickerComponent,
  },
  mixins: [formatMoneyMixin, formatDateMixin],
  data: function () {
    const today = new Date();
    const day = ('0' + today.getDate()).slice(-2);
    const month = ('0' + (today.getMonth() + 1)).slice(-2);
    const year = today.getFullYear();
    return {
      toDate: `${day}/${month}/${year}`,
      total: 0,
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        ajax: {
          url: process.env.VUE_APP_BASE_URL + "/api/reports/pacbalancestodate",
          type: "GET",
          data: (d) => {
            d.toDate = this.toDate;
            return d;
          },
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        },
        processing: true,
        pageLength: 50,
        searching: true,
        searchDelay: 400,
        destroy: true,
        order: [[3, 'desc']],
        ordering: true,
        lengthChange: true,
        serverSide: true,
        autoWidth: false,
      },
      fields: {
        name: {
          label: "Nombre",
          render: (data, type) =>
            type === 'display' ? `<span class="data-table__primary">${data || ''}</span>` : data,
        },
        cuit: { label: "CUIT" },
        business: { label: "Razón social" },
        total: {
          label: "Total",
          align: "right",
          render: this.formatoDinamicoMoneda,
        },
      },
    };
  },
  computed: {
    filters() {
      return {
        toDate: this.toDate,
      };
    },
  },
  watch: {
    filters() {
      this.reload();
    },
  },
  mounted() {
    this.getTotals();
  },
  methods: {
    reload() {
      this.getTotals();
      this.refreshTable();
    },
    refreshTable() {
      if (this.$refs.table !== undefined) this.$refs.table.reload();
    },
    toDateUpdated(date) {
      this.toDate = date;
    },
    getTotals() {
      this.$http.get("/api/reports/pacbalancestodatetotal", { params: this.filters })
        .then((response) => {
          this.total = response.data.data;
        })
        .catch((error) => {
          console.error('getTotals:', error);
        });
    },
    exportCSV() {
      this.$http.post("/api/reports/CSVPacBalances", this.filters);
    },
    exportPDF() {
      this.$http.post("/api/reports/PDFpacbalances", this.filters);
    },
  },
};
</script>

<style scoped>
.filters-panel__field--inline {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filters-panel__field--inline .control-label {
  margin: 0;
  white-space: nowrap;
  font-size: 13px;
  color: var(--text);
}

.filters-panel__field--inline > .form-group {
  flex: 1 1 auto;
  margin-bottom: 0;
}
</style>
